module.exports = __webpack_public_path__ + "e50c3eec60b8bdca4192df4078fc1e8e.png";